<template>
    <div class="d-flex min-vh-100">
        <Aside />
        <main class="flex-grow-1 bg-light">
            <div class="p-4">
                <div class="row g-4">
                    <div class="col-md-3">
                        <div class="card bg-primary text-white p-3">
                            <h5 class="card-title">Utilisateurs</h5>
                            <p class="card-text">{{ userCount }}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card bg-success text-white p-3">
                            <h5 class="card-title">Articles</h5>
                            <p class="card-text">{{ articleCount }}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card bg-warning text-white p-3">
                            <h5 class="card-title">Commentaires</h5>
                            <p class="card-text">{{ commentCount }}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card bg-info text-white p-3">
                            <h5 class="card-title">Podcasts</h5>
                            <p class="card-text">{{ podcastCount }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
    
</template>

<script>
import axios from '@/api/axios.js';
import Aside from '@/components/Aside.vue'

export default {
    components: {
        Aside
    },
    data() {
        return {
            userCount: 0,
            articleCount: 0,
            commentCount: 0,
            podcastCount: 0
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                const response = await axios.get('/dashboard/count');
                
                this.userCount = response.data.users_count;
                this.articleCount = response.data.articles_count;
                this.commentCount = response.data.comments_count;
                this.podcastCount = response.data.podcasts_count;
            } catch (error) {
            }
        }
    }
};
</script>
